// SmootherOPE から移したユーザーの口座情報（口座振替の口座）の型

// 一覧の 1 行。列は SmootherOPE と同じ（Bank Code の列には銀行名を出す）
export interface UserBankAccountListItem {
  id: number
  userId: number | null
  userName: string | null
  bankName: string | null
  branchCode: string | null
}

// 詳細。項目は SmootherOPE と同じ（決済代行の取引 ID は API も返さない）
export interface UserBankAccountDetail {
  id: number
  userId: number | null
  userName: string | null
  bankCode: string | null
  branchCode: string | null
  accountType: number | null
  accountNumber: string | null
  accountNameKana: string | null
  accountNameKanji: string | null
  errInfo: string | null
  result: string
  enabled: boolean
  createdAt: string
  updatedAt: string
}

export interface UserBankAccountListQuery {
  search: string
  page: number
}

export const userBankAccountHref = (id: number) => `/admin/bank-accounts/${id}`

export const userHref = (userId: number) => `/admin/users/${userId}`
